import myTheme from "../../../../src/themes/theme";
import React from 'react';
export default {
  myTheme,
  React
};